import { render } from "./PrimaryCareClinic.vue?vue&type=template&id=29a75538&scoped=true&lang=pug"
import script from "./PrimaryCareClinic.vue?vue&type=script&lang=js"
export * from "./PrimaryCareClinic.vue?vue&type=script&lang=js"

import "./PrimaryCareClinic.vue?vue&type=style&index=0&id=29a75538&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a75538"]])

export default __exports__